<template>
  <div class="flex-grid justify-center">
    <div class="col-full">
      <div class="box">
        <h1>Helaas, er is iets misgegaan</h1>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
